import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Search = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.49593 14C11.9937 14 14.8293 11.1645 14.8293 7.66668C14.8293 4.16887 11.9937 1.33334 8.49593 1.33334C4.99813 1.33334 2.1626 4.16887 2.1626 7.66668C2.1626 11.1645 4.99813 14 8.49593 14Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4959 14.6667L14.1626 13.3333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Search.displayName = 'Search';
